

export default {
    // getSelectedCategory: state => state.selectedCategory,
    getMode: state => state.mode,
    getVersion: state => state.kind,
    getChannelGroupData: state => state.channelGroupData,
    // getCategoryId: state => state.categoryId,
    // getCategoryNum: state => state.categoryNum,
    getChannelTimeFrom: state => state.channelTimeFrom,
    getChannelTimeTo: state => state.channelTimeTo,
    getCustomChannelIds: state => state.customChannelIds,

    getSelectedChannelGroupId: ( state, getters ) => { 
      return state.selectedChannelGroupIdMap[state.selectedChannelOriginId] 
        ? state.selectedChannelGroupIdMap[state.selectedChannelOriginId]
        : getters.getChannelGroupListByOrigin(state.selectedChannelOriginId) && getters.getChannelGroupListByOrigin(state.selectedChannelOriginId).length > 0
        ? getters.getChannelGroupListByOrigin(state.selectedChannelOriginId)[0].channelGroup.channel_group_id
        : null;
    },

    getChannelOriginList: state => {
      let originList = Object.values(state.channelOriginsMap);
      originList.sort((a, b) => {
        // sort_orderでソート
        let comparison = 0;
        if (a.sort_order > b.sort_order) {
          comparison = 1;
        } else if (a.sort_order < b.sort_order) {
          comparison = -1;
        }
        return comparison ;
      });
      return originList;
    },

    getChannelGroupListByOrigin: state => originId => {
      if ( originId === 'custom') {
        return [];
      }
      let groupList = Object.values(state.channelGroupsMapByOrigin[originId]);
      groupList.sort((a, b) => {
        // sort_orderでソート
        let comparison = 0;
        if (a.channelGroup.sort_order > b.channelGroup.sort_order) {
          comparison = 1;
        } else if (a.channelGroup.sort_order < b.channelGroup.sort_order) {
          comparison = -1;
        }
        return comparison ;
      });
      return groupList;    
    },
    
}